function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import Loader from '../../shared/Loader';
import Modal from '../../shared/Modal';
export default function Delete(_ref) {
  var appProps = _ref.appProps,
    pageName = _ref.pageName,
    pageTitle = _ref.pageTitle;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    confirmModal = _useState4[0],
    setConfirmModal = _useState4[1];
  function deleteAccount() {
    setConfirmModal(false);
    setLoading(true);
    Rails.ajax({
      type: 'POST',
      url: '/account/delete',
      dataType: 'json',
      success: function success(res) {
        window.location.href = "/";
      },
      error: function error(res) {
        setLoading(false);
      }
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "section-title"
  }, /*#__PURE__*/React.createElement("h3", null, pageTitle)), /*#__PURE__*/React.createElement("div", {
    className: "flex-box ".concat(pageName)
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://storage.googleapis.com/reactive_files_eu/delete_account_image.jpg"
  })), /*#__PURE__*/React.createElement("div", {
    className: "notice-wrapper"
  }, appProps.user.fullname && /*#__PURE__*/React.createElement("h2", null, " ", appProps.user.fullname, " "), /*#__PURE__*/React.createElement("p", null, " ", appProps.translations.account.delete_account_button_label, " "), /*#__PURE__*/React.createElement("div", {
    className: "button-wrapper flex-box content-end",
    style: {
      marginTop: 20
    }
  }, loading ? /*#__PURE__*/React.createElement(Loader, {
    size: 'medium',
    position: 'center'
  }) : /*#__PURE__*/React.createElement("button", {
    type: "submit",
    id: "delete-account",
    className: "button",
    onClick: function onClick() {
      return setConfirmModal(true);
    }
  }, appProps.translations.account.delete_account))))), confirmModal && /*#__PURE__*/React.createElement(Modal, {
    visible: true,
    mode: "small",
    elementsClass: "content-center",
    icon: 'exclamation',
    theme: "body-bg",
    closeModal: function closeModal() {
      return setConfirmModal(false);
    },
    abortAction: function abortAction() {
      return setConfirmModal(false);
    },
    abortText: appProps.translations.general.cancel,
    acceptAction: function acceptAction() {
      return deleteAccount();
    },
    saveText: appProps.translations.account.delete_account
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: 'center'
    }
  }, appProps.translations.account.delete_account_confirm)));
}